import { render } from "./BasicUsage.vue?vue&type=template&id=2bbf0797"
import script from "./BasicUsage.vue?vue&type=script&lang=ts"
export * from "./BasicUsage.vue?vue&type=script&lang=ts"
script.render = render

export default script